import { Modal, ModalProps } from "react-bootstrap";

interface SelectHobbyConfirmModalProps extends ModalProps {
  onHide: () => void;
  hobbyName: string;
  hobbyImageUrl: string;
  fallbackImage: string;
  onConfirm: () => void;
  isLandscapeArt?: boolean;
  /** When set (group photo flow), show which person this hobby is for. */
  personNumber?: number;
}

const SelectHobbyConfirmModal = (props: SelectHobbyConfirmModalProps) => {
  const {
    hobbyName,
    hobbyImageUrl,
    fallbackImage,
    onConfirm,
    onHide,
    isLandscapeArt = false,
    personNumber,
    ...modalProps
  } = props;

  return (
    <Modal
      {...modalProps}
      className="selectHobbyConfirmModal"
      keyboard={false}
      centered
      scrollable={false}
      onHide={onHide}
    >
      <Modal.Body className="px-0">
        <div className="otpModalBody py-2">
          <div className="header mb-3">
            {typeof personNumber === "number" && personNumber > 0
              ? `You selected for Person ${personNumber}`
              : "You selected"}
          </div>
          <div className={`selectHobbyConfirmImageWrap${isLandscapeArt ? " isArtLandscape" : " isArtSquare"}`}>
            <img
              src={hobbyImageUrl || fallbackImage}
              alt={hobbyName}
              onError={(e) => {
                const el = e.currentTarget;
                if (!el.dataset.fallbackApplied) {
                  el.dataset.fallbackApplied = "1";
                  el.src = fallbackImage;
                }
              }}
            />
          </div>
          <div className="selectHobbyConfirmActions">
            <button type="button" className="btnYesMenu" onClick={onConfirm}>
              Yes
            </button>
            <button type="button" className="btnCancelMenu" onClick={onHide}>
              No
            </button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default SelectHobbyConfirmModal;
